import script from "./ManagePlan.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagePlan.vue?vue&type=script&setup=true&lang=js"

import "./ManagePlan.vue?vue&type=style&index=0&id=5796ffb8&scoped=true&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5796ffb8"]])

export default __exports__